import { render, staticRenderFns } from "./ModalAreaEdit.vue?vue&type=template&id=64c01f00&scoped=true"
import script from "./ModalAreaEdit.vue?vue&type=script&lang=js"
export * from "./ModalAreaEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalAreaEdit.vue?vue&type=style&index=0&id=64c01f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c01f00",
  null
  
)

export default component.exports